import { type WorkTab_userProfile$key } from '#app/__generated__/relay/WorkTab_userProfile.graphql.js';
import { RoutingTabs } from '#app/components/RoutingTabs/RoutingTabs.js';
import { useAnalytics } from '#app/hooks/useAnalytics.js';
import { useRouter } from '#app/hooks/useRouter.js';
import { graphql, useFragment } from '@contra/relay';
import { getRoute } from '@contra/routes';

type WorkTabProps = {
  readonly userProfileRef: WorkTab_userProfile$key;
};

export const WorkTab = ({ userProfileRef }: WorkTabProps) => {
  const userProfile = useFragment<WorkTab_userProfile$key>(
    graphql`
      fragment WorkTab_userProfile on UserProfile {
        displayUsername
        profileDisplayType
        visitorCanEdit
        analyticsId
      }
    `,
    userProfileRef,
  );
  const { analyticsId, displayUsername, profileDisplayType, visitorCanEdit } =
    userProfile;
  const { isActive } = useRouter();
  const { track } = useAnalytics();

  const isBlogProfile = profileDisplayType === 'BLOG';

  return (
    <RoutingTabs.Tab
      match={() => {
        return [
          getRoute('/'),
          getRoute('/@username', {
            args: {
              username: displayUsername,
            },
          }),
          getRoute('/@username/projects', {
            args: {
              username: displayUsername,
            },
          }),
          // Blog-related routes
          `${getRoute('/@username', {
            args: {
              username: displayUsername,
            },
          })}/for-independents`,
          `${getRoute('/@username', {
            args: {
              username: displayUsername,
            },
          })}/for-clients`,
        ].some((routeName) => {
          return isActive(routeName, true);
        });
      }}
      onClick={() => {
        if (userProfile)
          track('tab', {
            action: 'tapped',
            is_owner: visitorCanEdit,
            owner_id: analyticsId,
            tab_name: 'profile_projects',
          });
      }}
      to={getRoute('/@username', {
        args: {
          username: displayUsername,
        },
      })}
    >
      {isBlogProfile ? 'My Work' : 'Work'}
    </RoutingTabs.Tab>
  );
};
